module.exports = __webpack_public_path__ + "img/junction-bold.a8c7a1b5.svg";